<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="700px"
      @click:outside="cerrarDialogo()"
      content-class="incident-dialog-wrap"
    >
      <v-card class="incident-resp-card">
        <!-- Cabecera Moderna de la Modal -->
        <div
          class="incident-resp-header px-6 py-4 d-flex align-center justify-space-between"
        >
          <div class="d-flex align-center">
            <div class="header-icon-box mr-3">
              <v-icon color="teal darken-2">mdi-headset</v-icon>
            </div>
            <div>
              <div class="header-modal-title">Detalle de la Incidencia</div>
              <div class="d-flex align-center mt-1 flex-wrap">
                <span class="ticket-id-badge mr-2">
                  Ticket #{{
                    (datos_param &&
                      (datos_param.identificador || datos_param.id)) ||
                    "S/N"
                  }}
                </span>
                <span
                  class="ticket-date-badge"
                  v-if="datos_param && datos_param.fecha"
                >
                  <v-icon x-small class="mr-1" color="teal"
                    >mdi-calendar-clock</v-icon
                  >
                  {{ formatearFecha(datos_param.fecha) }}
                </span>
              </div>
            </div>
          </div>
          <v-btn
            icon
            small
            class="close-resp-btn"
            @click="cerrarDialogo()"
            aria-label="Cerrar modal"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="incident-resp-body px-6 py-4">
          <!-- Sección 1: Datos del Cliente -->
          <div class="section-card mb-4">
            <div class="section-card-header d-flex align-center">
              <div class="section-icon-dot bg-blue mr-2"></div>
              <v-icon small color="primary" class="mr-2">mdi-domain</v-icon>
              <span class="section-card-title">Datos del Cliente</span>
            </div>
            <div class="section-card-content pt-3">
              <v-row dense>
                <v-col cols="12" sm="7">
                  <v-text-field
                    label="Razón Social"
                    hide-details="auto"
                    v-model="datos_param.razon_social"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-office-building-outline"
                    class="custom-readonly-field"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="5">
                  <v-text-field
                    label="RUC"
                    hide-details="auto"
                    v-model="datos_param.ruc"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-card-account-details-outline"
                    class="custom-readonly-field"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- Sección 2: Detalles del Incidente -->
          <div class="section-card mb-4">
            <div class="section-card-header d-flex align-center">
              <div class="section-icon-dot bg-amber mr-2"></div>
              <v-icon small color="amber darken-3" class="mr-2"
                >mdi-alert-circle-outline</v-icon
              >
              <span class="section-card-title">Detalles del Incidente</span>
            </div>
            <div class="section-card-content pt-3">
              <v-form ref="form" v-model="valid">
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Usuario Reportante"
                      hide-details="auto"
                      :value="
                        datos_param.usuario ? datos_param.usuario.name : ''
                      "
                      outlined
                      dense
                      readonly
                      prepend-inner-icon="mdi-account-outline"
                      class="custom-readonly-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Fecha de Registro"
                      hide-details="auto"
                      :value="formatearFecha(datos_param.fecha)"
                      outlined
                      dense
                      readonly
                      prepend-inner-icon="mdi-calendar-range"
                      class="custom-readonly-field"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="mt-2">
                    <v-textarea
                      label="Descripción del Problema"
                      v-model="datos_param.descripcion"
                      outlined
                      dense
                      readonly
                      rows="3"
                      auto-grow
                      prepend-inner-icon="mdi-text-box-outline"
                      class="custom-readonly-field"
                    />
                  </v-col>
                </v-row>

                <!-- Sección 3: Evidencias Fotográficas -->
                <div class="evidence-section mt-3">
                  <div class="d-flex align-center mb-2">
                    <v-icon small color="blue-grey" class="mr-2"
                      >mdi-camera-outline</v-icon
                    >
                    <span class="evidence-label">Evidencias Fotográficas</span>
                  </div>
                  <v-row dense>
                    <!-- Imagen 1 -->
                    <v-col cols="12" sm="6">
                      <div class="evidence-box">
                        <div class="evidence-box-header">
                          <span class="d-flex align-center">
                            <v-icon x-small color="teal" class="mr-1"
                              >mdi-image-outline</v-icon
                            >
                            Evidencia 1
                          </span>
                          <span
                            class="evidence-state-tag"
                            v-if="datos_param.image_one != null"
                            >Adjunta</span
                          >
                        </div>
                        <div class="evidence-box-body">
                          <div
                            v-if="datos_param.image_one != null"
                            class="evidence-img-wrapper"
                            @click="verImagenGrande(image_one)"
                            title="Click para ampliar imagen"
                          >
                            <img
                              id="imagenFirmaPrevio"
                              :src="
                                datos_param.image_one ? image_one : image_one
                              "
                              alt="Evidencia 1"
                              class="evidence-img"
                            />
                            <div class="evidence-zoom-overlay">
                              <v-icon small color="white"
                                >mdi-magnify-plus-outline</v-icon
                              >
                              <span
                                class="ml-1 text-caption white--text font-weight-medium"
                                >Ampliar</span
                              >
                            </div>
                          </div>
                          <div v-else class="evidence-empty-box">
                            <v-icon color="grey lighten-1"
                              >mdi-image-off-outline</v-icon
                            >
                            <span class="evidence-empty-text"
                              >Sin imagen cargada</span
                            >
                          </div>
                        </div>
                      </div>
                    </v-col>

                    <!-- Imagen 2 -->
                    <v-col cols="12" sm="6">
                      <div class="evidence-box">
                        <div class="evidence-box-header">
                          <span class="d-flex align-center">
                            <v-icon x-small color="teal" class="mr-1"
                              >mdi-image-outline</v-icon
                            >
                            Evidencia 2
                          </span>
                          <span
                            class="evidence-state-tag"
                            v-if="datos_param.image_two != null"
                            >Adjunta</span
                          >
                        </div>
                        <div class="evidence-box-body">
                          <div
                            v-if="datos_param.image_two != null"
                            class="evidence-img-wrapper"
                            @click="verImagenGrande(image_two)"
                            title="Click para ampliar imagen"
                          >
                            <img
                              id="imagenFirmaPrevio"
                              :src="
                                datos_param.image_two ? image_two : image_two
                              "
                              alt="Evidencia 2"
                              class="evidence-img"
                            />
                            <div class="evidence-zoom-overlay">
                              <v-icon small color="white"
                                >mdi-magnify-plus-outline</v-icon
                              >
                              <span
                                class="ml-1 text-caption white--text font-weight-medium"
                                >Ampliar</span
                              >
                            </div>
                          </div>
                          <div v-else class="evidence-empty-box">
                            <v-icon color="grey lighten-1"
                              >mdi-image-off-outline</v-icon
                            >
                            <span class="evidence-empty-text"
                              >Sin imagen cargada</span
                            >
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Sección 4: Vehículo y Neumático (si aplica) -->
                <div
                  class="neumatico-section mt-4"
                  v-if="
                    datos_param.id_vehiculo != null ||
                    datos_param.id_neumatico != null
                  "
                >
                  <div class="d-flex align-center mb-2">
                    <v-icon small color="teal darken-2" class="mr-2"
                      >mdi-car-tire-alert</v-icon
                    >
                    <span class="evidence-label"
                      >Vehículo y Neumáticos Involucrados</span
                    >
                  </div>
                  <div class="custom-table-container">
                    <table class="custom-incident-table">
                      <thead>
                        <tr>
                          <th>
                            <div class="d-flex align-center">
                              <v-icon x-small color="slate" class="mr-1"
                                >mdi-truck-outline</v-icon
                              >
                              <span>Placa del Vehículo</span>
                            </div>
                          </th>
                          <th>
                            <div class="d-flex align-center">
                              <v-icon x-small color="slate" class="mr-1"
                                >mdi-barcode</v-icon
                              >
                              <span>Serie del Neumático</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in datos_param.neumatico"
                          :key="index"
                        >
                          <td>
                            <span class="badge-placa">
                              <v-icon x-small class="mr-1" color="primary"
                                >mdi-truck</v-icon
                              >
                              {{ datos_param.vehiculo }}
                            </span>
                          </td>
                          <td>
                            <span class="badge-serie">
                              <v-icon x-small class="mr-1" color="grey darken-2"
                                >mdi-barcode</v-icon
                              >
                              {{ item }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </v-form>
            </div>
          </div>
        </v-card-text>

        <!-- Pie de la Modal / Acciones -->
        <v-divider></v-divider>
        <v-card-actions class="incident-resp-actions px-6 py-3">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class="btn-resp-secondary text-capitalize"
            @click="cerrarDialogo()"
          >
            <v-icon small class="mr-1">mdi-close</v-icon>
            Cerrar
          </v-btn>
          <!-- <v-btn
            color="teal darken-1"
            class="btn-resp-primary white--text text-capitalize ml-2"
            @click="guardarIncidencia()"
            :loading="loading"
            elevation="0"
          >
            <v-icon small class="mr-1">mdi-content-save-outline</v-icon>
            Guardar
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Modal para ampliar la fotografía -->
    <v-dialog v-model="dialogPreviewImagen" max-width="820px">
      <v-card class="preview-img-card">
        <div
          class="preview-header px-4 py-3 d-flex justify-space-between align-center"
        >
          <div class="d-flex align-center">
            <v-icon small color="teal darken-2" class="mr-2"
              >mdi-image-search-outline</v-icon
            >
            <span class="text-subtitle-2 font-weight-bold"
              >Fotografía de Evidencia</span
            >
          </div>
          <v-btn
            icon
            small
            @click="dialogPreviewImagen = false"
            aria-label="Cerrar vista previa"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="preview-body pa-4 text-center">
          <img
            :src="imagenSeleccionada"
            alt="Evidencia Ampliada"
            class="preview-full-img"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { notif } from "@/plugins/notyf";
import global from "@/global";
import moment from "moment";

export default {
  props: ["dialog", "datos"],
  data() {
    return {
      valid: false,
      loading: false,
      incidente: {},
      descripcionRules: [
        (v) => !!v || "Descripción es requerido",
        (v) =>
          (v && v.length <= 1000) ||
          "Descripción debe tener menos de 1000 caracteres",
      ],
      item: {
        aplicativo: "vue",
        descripcion: "",
        image_one: null,
        image_two: null,
      },
      cabecera: [
        {
          text: "Placa",
          value: "placa_vehiculo",
          width: 200,
          class: "grey darken-1 dark white--text",
        },
        {
          text: "Serie",
          value: "serie_neumatico",
          width: 200,
          class: "grey darken-1 dark white--text",
        },
        {
          text: "Opcion",
          value: "accion",
          width: 100,
          class: "grey darken-1 dark white--text",
        },
      ],
      items: [],
      vehiculo: {},
      vehiculos: [],
      neumaticos: [],
      incidente: {
        placa: null,
        serie: null,
        id_neumatico: null,
        id_vehiculo: null,
      },
      nombreusuario: "",
      datos_param: this.datos || {},
      image_one: "",
      image_two: "",
      dialogPreviewImagen: false,
      imagenSeleccionada: "",
    };
  },
  watch: {
    datos: {
      immediate: true,
      handler(val) {
        if (val) {
          this.datos_param = val;
          if (val.image_one) {
            this.image_one = global.ruta_image + val.image_one;
          }
          if (val.image_two) {
            this.image_two = global.ruta_image + val.image_two;
          }
        }
      },
    },
  },
  computed: {},
  methods: {
    ...mapActions("incidente", ["subirImagenes", "guardarIncidente"]),

    formatearFecha(fecha) {
      if (!fecha) return "";
      const m = moment(fecha);
      if (m.isValid()) {
        return m.format("DD/MM/YYYY");
      }
      return fecha;
    },

    verImagenGrande(src) {
      if (src) {
        this.imagenSeleccionada = src;
        this.dialogPreviewImagen = true;
      }
    },

    onSerieNeumatico() {
      this.neumaticos.forEach((element) => {
        if (element.value == this.incidente.id_neumatico) {
          this.incidente.serie_neumatico = element.text;
        }
      });
    },

    async guardarIncidencia() {
      let status = false;
      if (this.$refs.form.validate()) {
        try {
          let datosaenviar = { incidente: this.item, detalles: this.items };
          status = await this.guardarIncidente(datosaenviar);
          if (status == true) {
            notif.success("Incidencia enviada con éxito");
            this.cerrarDialogo();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    agregarIncidencia() {
      let existe = false;
      this.items.forEach((element) => {
        if (
          element.id_vehiculo == this.incidente.id_vehiculo &&
          element.id_neumatico == this.incidente.id_neumatico
        ) {
          existe = true;
        }
      });
      //Si el neumatico no esta en el array incidentes registrar
      if (!existe) {
        if (
          this.incidente.id_vehiculo != null &&
          this.incidente.id_neumatico != null
        ) {
          this.items.push({ ...this.incidente });
        } else {
          if (this.incidente.id_vehiculo == null) {
            notif.open({
              type: "warning",
              message: "La placa del vehículo es requerida",
            });
          } else {
            notif.open({
              type: "warning",
              message: "La serie de neumático es requerida",
            });
          }
        }
      } else {
        notif.open({
          type: "warning",
          message: "El neumático seleccionado ya a sido agregado",
        });
      }
      this.incidente.serie_neumatico = null;
      this.incidente.id_neumatico = null;
    },

    eliminarItem(item) {
      const pos = this.items.indexOf(item);
      this.items.splice(pos, 1);
    },

    async subirImagen1() {
      try {
        let file = document.getElementById("img_firma1").files[0];
        this.item.image_one = await this.subirImagenes(file);
      } catch (error) {
        console.log(error);
      }
    },

    async subirImagen2() {
      try {
        let file = document.getElementById("img_firma1").files[0];
        this.item.image_two = await this.subirImagenes(file);
      } catch (error) {
        console.log(error);
      }
    },

    cerrarDialogo() {
      this.$emit("cerrarModalRespuestaIncidencias");
    },
  },
  async mounted() {
    this.nombreusuario = localStorage.getItem("name");
    if (this.datos_param) {
      if (this.datos_param.image_one) {
        this.image_one = global.ruta_image + this.datos_param.image_one;
      }
      if (this.datos_param.image_two) {
        this.image_two = global.ruta_image + this.datos_param.image_two;
      }
    }
  },
};
</script>

<style scoped>
.incident-resp-card {
  border-radius: 16px !important;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.incident-resp-header {
  background: #f8fafc;
  border-bottom: 1px solid #edf2f7;
}

.header-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #ccfbf1;
  border: 1px solid #99f6e4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.header-modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.ticket-id-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  background: #ccfbf1;
  color: #0f766e;
  border: 1px solid #99f6e4;
}

.ticket-date-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

.close-resp-btn {
  color: #64748b !important;
  transition: all 0.2s ease;
}

.close-resp-btn:hover {
  background: #f1f5f9;
  color: #0f172a !important;
}

.incident-resp-body {
  max-height: 72vh;
  overflow-y: auto;
  background: #ffffff;
}

/* Scrollbar estilizado */
.incident-resp-body::-webkit-scrollbar {
  width: 6px;
}
.incident-resp-body::-webkit-scrollbar-track {
  background: #f8fafc;
}
.incident-resp-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.incident-resp-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Tarjetas de sección */
.section-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  transition: all 0.2s ease;
}

.section-card:hover {
  border-color: #cbd5e1;
}

.section-card-header {
  border-bottom: 1px dashed #f1f5f9;
  padding-bottom: 8px;
}

.section-icon-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.bg-blue {
  background-color: #3b82f6;
}

.bg-amber {
  background-color: #f59e0b;
}

.section-card-title {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* Campos readonly con aspecto sutil */
::v-deep .custom-readonly-field .v-input__slot {
  background: #f8fafc !important;
  border-color: #e2e8f0 !important;
  font-size: 12.5px !important;
  border-radius: 8px !important;
}

::v-deep .custom-readonly-field input,
::v-deep .custom-readonly-field textarea {
  color: #1e293b !important;
  font-weight: 500;
}

::v-deep .custom-readonly-field .v-icon {
  font-size: 17px !important;
  color: #94a3b8 !important;
}

/* Evidencias fotográficas */
.evidence-label {
  font-size: 11.5px;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.evidence-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.evidence-box:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
}

.evidence-box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background: #f1f5f9;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
}

.evidence-state-tag {
  font-size: 10px;
  font-weight: 700;
  color: #0f766e;
  background: #ccfbf1;
  padding: 1px 6px;
  border-radius: 4px;
}

.evidence-box-body {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}

.evidence-img-wrapper {
  position: relative;
  width: 100%;
  height: 115px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: #0f172a;
}

.evidence-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.evidence-img-wrapper:hover .evidence-img {
  transform: scale(1.05);
}

.evidence-zoom-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.evidence-img-wrapper:hover .evidence-zoom-overlay {
  opacity: 1;
}

.evidence-empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
  color: #94a3b8;
}

.evidence-empty-text {
  font-size: 11px;
  margin-top: 4px;
}

/* Tabla personalizada */
.custom-table-container {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}

.custom-incident-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.custom-incident-table th {
  background: #f1f5f9;
  color: #475569;
  font-weight: 700;
  padding: 8px 12px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.custom-incident-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
}

.custom-incident-table tbody tr:last-child td {
  border-bottom: none;
}

.custom-incident-table tbody tr:hover {
  background: #f8fafc;
}

.badge-placa {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 700;
  font-size: 11px;
  border: 1px solid #dbeafe;
}

.badge-serie {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  background: #f8fafc;
  color: #334155;
  font-weight: 600;
  font-size: 11px;
  border: 1px solid #e2e8f0;
}

.incident-resp-actions {
  background: #f8fafc;
}

.btn-resp-secondary {
  border-radius: 8px !important;
  color: #64748b !important;
  border-color: #cbd5e1 !important;
}

.btn-resp-secondary:hover {
  background: #f1f5f9 !important;
  color: #1e293b !important;
}

.btn-resp-primary {
  border-radius: 8px !important;
  box-shadow: 0 2px 6px rgba(13, 148, 136, 0.25) !important;
}

.preview-img-card {
  border-radius: 14px;
  overflow: hidden;
}

.preview-header {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.preview-full-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
</style>
